module.exports = __webpack_public_path__ + "img/c3.7b0b5b9f.jpg";